import { StyleSheet } from 'react-native-web';
import GLOBAL from '../../configs/config_global';

const styles = StyleSheet.create({
    sheetContainer: {
        paddingLeft: 24,
        paddingRight: 24
    },
    titleContainer: {
        ...StyleSheet.absoluteFill,
        alignItems: 'center',
        justifyContent: 'center'
    },
    title: {
        color: 'black',
        fontSize: 18,
        fontWeight: 'bold',
        textAlign: 'center',
        textAlignVertical: 'center'
    },
    header: {
        alignSelf: 'stretch',
        flexDirection: 'row',
        alignItems: 'center',
        borderBottomColor: GLOBAL.COLOR.DIVIDER,
        borderBottomWidth: 1,
        height: 64,
        paddingHorizontal: 24
    },
    childContainer: {
        alignSelf: 'stretch',
        flex: 1,
        paddingTop: 8
    },
    closeButton: {
        backgroundColor: GLOBAL.COLOR.MAIN,
        marginHorizontal: 24
    },
    cancelText: {
        fontSize: 18,
        color: 'black'
    },
    gradientView: {
        position: 'absolute',
        left: 0,
        right: 0,
        height: 40
    }
});

export default styles;
